import { Table, TableHead, TableBody, TableRow, TableCell, Stack } from "@mui/material";

import PaginationControlsV2 from "../../../../../global/PaginationControlsV2";
import { STRINGS } from "../../config/strings";

import ProviderTableRow from "./ProviderTableRow";

export default function ProviderTable({
  displayedData,
  assignedProvider,
  data,
  resultCount,
  currentPage,
  resLimit,
  handlePageChange,
  onClickDetail,
  onSelect,
  onDeselect,
  address,
  initAddress,
}) {
  return (
    <div className="flex flex-col gap-2 p-2 justify-between w-full h-full relative">
      <div className="relative w-full h-full">
      <div className="absolute left-0 bottom-0 right-0 top-0 overflow-y-auto [&::-webkit-scrollbar-thumb]:bg-blue-700 [&::-webkit-scrollbar]:[width:6px]">
        <Table sx={{ tableLayout: "auto", width: "100%" }}>
          <TableHead>
            <TableRow>
              <TableCell sx={{ width: "40%" }}>Name</TableCell>
              <TableCell sx={{ width: "30%" }}>Type</TableCell>
              <TableCell sx={{ width: "5%" }}>Rating</TableCell>
              <TableCell sx={{ width: "20%" }}>Distance</TableCell>
              <TableCell sx={{ width: "auto" }}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {displayedData?.map((row) => (
              <ProviderTableRow
                key={row.id}
                row={row}
                assignedProvider={assignedProvider}
                onClickDetail={onClickDetail}
                onSelect={onSelect}
                onDeselect={onDeselect}
                address={address}
                initAddress={initAddress}
              />
            ))}
          </TableBody>
        </Table>
      </div>
      </div>
      {
      !(resultCount < STRINGS.DEFAULT_PAGINATION_LIMIT) &&
      <div
        className={`flex w-full justify-center ${assignedProvider ? "invisible" : "visible"}`}
      >
        <Stack alignItems="center">
          <PaginationControlsV2
            alignment="center"
            resultCount={resultCount}
            handleChange={handlePageChange}
            currentPage={currentPage}
            resultLimit={resLimit}
          />
        </Stack>
      </div>
    }
    </div>
  );
}
